import script from "./ChatLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatLayout.vue?vue&type=script&setup=true&lang=js"

import "./ChatLayout.vue?vue&type=style&index=0&id=9cbc8812&lang=scss"

const __exports__ = script;

export default __exports__